import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(private httpClientService:HttpClientService) { }
  
  async getAllPageCurrency(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Currency,
      queryString:`Page=${page}&Size=${size}&Search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async createCurrency(currencyName){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Currency,
    },{
      currencyName:currencyName
    });
    return await firstValueFrom(observable);
  }

  async updateCurrency(id,currencyName){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Currency,
    },{
      id:id,
      currencyName:currencyName
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
